import { STANDARDS_SET_MODE } from "@/search/Langston/types/IStandardsSetMode";
import { IStandardsModalContext } from "./StandardsModalProvider.types";

export const initialStandardsModalContext: IStandardsModalContext = {
  getters: {
    currentStandards: [],
    newStandardsSet: {
      id: "",
      title: "",
      children: [],
      viewmodel_type: "list_type",
    },
    createdStandardsSets: [],
    selectedSubjectFilter: "-",
    selectedDateFilter: "-",
    filteredStandards: [],
    availableDates: [],
    availableSubjects: [],
    standardsSetMode: STANDARDS_SET_MODE.VIEW,
    confirmModalData: {},
    isEditingSet: false,
    isConfirmActionModalOpen: false,
    standardsSetTitleError: null,
    modalTabs: [],
    draftStandardsSetId: null,
    operationErrorMessage: "",
    isPublishingStandardsSet: false,
    isUpdatingStandardsSet: false,
    isDeletingStandardsSet: false,
    allowModalTabAutoChanges: false,
    needle: "",
  },
  handlers: {
    setCurrentStandards: () => null,
    setNewStandardsSet: () => null,
    addNewStandardsSet: () => null,
    editStandardsSet: () => null,
    deleteStandardsSet: () => null,
    setSelectedDateFilter: () => null,
    setSelectedSubjectFilter: () => null,
    setFilteredStandards: () => null,
    openConfirmModal: () => null,
    closeConfirmModal: () => null,
    setStandardsSetMode: () => null,
    handleApplyConfirmModal: () => null,
    setConfirmModalData: () => null,
    setIsEditingSet: () => null,
    setStandardsSetTitleError: () => null,
    switchEditDataOnTabChange: () => null,
    setModalTabs: () => null,
    setDraftStandardsSetId: () => null,
    handleCreateDraftStandardsSet: () => Promise.resolve(),
    setAllowModalTabAutoChanges: () => null,
    setNeedle: () => null,
  },
};
